export interface Mechanism {
  number: string
  title: string
  intro: string
  effects: string[]
  result: string
  image: string
  imageAlt: string
}

export const mechanisms: Mechanism[] = [
  {
    number: 'Mecanismo 1',
    title: 'El secuestro de sodio',
    intro:
      'Tu sistema renal recibe una orden: “Retén sodio, porque el cuerpo está en peligro y necesita agua para sobrevivir”. Esto provoca una retención hídrica masiva.',
    effects: [
      'Hace que tu cara se vea redonda e inflamada',
      'Marca profundamente tus tobillos cuando te sacas los calcetines',
      'Oculta completamente la definición de tu cuerpo',
    ],
    result: 'Te despiertas 2-3 kg más “pesada” de lo que dormiste, solo por agua.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/254afadd-968e-43b8-8dea-0e3d3b25056a.jpg',
    imageAlt:
      'Ilustración de una silueta femenina con una capa de agua retenida y cristales de sal alrededor',
  },
  {
    number: 'Mecanismo 2',
    title: 'El apagado digestivo',
    intro:
      'Cuando tu cuerpo cree que está en peligro, desactiva procesos “no esenciales” como la digestión. Gastar energía en digerir no es prioritario si tienes que luchar o huir.',
    effects: [
      'Gases e inflamación abdominal incluso tras comer algo “sano”',
      'Fermentación de alimentos en el intestino',
      'Retención de heces: tu intestino literalmente “guarda” el contenido',
      'Esa sensación de pesadez después de cada comida',
    ],
    result: 'Tu abdomen se ve abultado incluso cuando comes poco.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/eda50e05-8fc7-4560-8cda-89011e8ecc73.jpg',
    imageAlt:
      'Ilustración del sistema digestivo apagado, con burbujas que representan gases e inflamación',
  },
  {
    number: 'Mecanismo 3',
    title: 'El almacenamiento de emergencia',
    intro:
      'El cortisol ordena liberar azúcar en sangre para tener “energía para correr”. Pero tú estás sentada en una oficina, no corriendo: esa azúcar no se gasta y tu cuerpo la guarda cerca de los órganos vitales.',
    effects: [
      'Glucosa liberada que nunca llega a quemarse',
      'Almacenamiento prioritario en el abdomen bajo',
      'Es como guardar gasolina “por si acaso” en la zona del tanque',
    ],
    result: 'Acumulación de grasa visceral en el abdomen, aunque comes “bien”.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d0587f1b-c468-4aa9-b790-3b675b49b009.jpg',
    imageAlt:
      'Ilustración del abdomen bajo como zona de almacenamiento de glucosa y grasa visceral',
  },
]
